import '../../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from '../generic.view.ts';
import Handlebars from 'handlebars';

import Template from 'text-loader!../../templates/appointments/appointments.template.html';
import Collection from '../../collections/appointments/appointments.paginated.collection.ts';
import Model from '../../models/appointments/appointment.model.ts';

import '../../../libs/bootstrap/js/bootstrap-table.js';

import i18n  from "l10n";
import popup from 'popup';

import 'jqueryUI';

import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

import AppointmentRowView from './appointment.row.view.ts';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	collection: null,
	model: null,
	isFirstDisplay: true,
	lastSearchedText: "",
	queueAppointmentStompSubscriptions: null,
	initialize: function (options) {
		var self = this;

        this.userData = options ? options.userData : null;

		this.collection = new Collection();
		this.collection.state.pageSize = 999999;
		this.collection.on( 'sync', this.successData, this );
		this.collection.on( 'error', this.errorData, this );

        this.render();

        this.setListener(); // stomp listener

		this.collection.url = 'rest/api/appointments/all';
		this.collection.getFirstPage();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template());
	},
	events: {

	},
	unbindEvents: function() {
	    this.unsubscribeStomp();
	},
	unsubscribeStomp: function() {
	    this.queueAppointmentStompSubscriptions.unsubscribe();
	    this.queueAppointmentStompSubscriptions = null;
	},
	subscribeToStomp: function() {
	    var self = this;
	    if(self.queueAppointmentStompSubscriptions != null) // already subscribed
	        return;

        var pathToStomp = this.userData.privilegeLevel == "SupervisingAdmin"
            ? "admin"
            : (this.userData.privilegeLevel == "OrganizationAdmin"
                ? "org/" +this.userData.orgId
                : ( this.userData.privilegeLevel == "VenueAdmin"
                    ? "venue/" + this.userData.venueId
                    : null
                  )
              );

        if(pathToStomp == null)
            return;

        self.queueAppointmentStompSubscriptions = self.client.subscribe("/live/monitors/appointments/" + pathToStomp, function (message){
            var responseObject = JSON.parse( message.body );

            self.renderSpecificAppointment(responseObject.object);
        });
    },
    setListener: function()
    {
        var self = this;

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

        var headers = {
            //origin: 'https://www.qedis-metro.com', toDo: enable it
        };

        this.client.connect(headers,
            function(frame) {
                self.subscribeToStomp(self);
            },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    //
                    console.log("connection closed");
                }
            }
        );
    },
	successData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		var $appointmentContainer = $("#table-container").find(".appointmentsContainer");

		this.renderAppointments($appointmentContainer, this.collection.models);
	},
	errorData: function(collection, xhr, options)
	{
 		this.onErrorHandler(collection, xhr, options);
	},
	renderAppointments: function($appointmentsContainer, models) {
	    var self = this;

	    $appointmentsContainer.empty();
        for(var i=0; i<models.length; i++) {
            var tempModel = models[i].toJSON();

            var options = {
                "model": tempModel,
                "socket": this.socket,
                "client": this.client,
            };

            var appointmentRowView = new AppointmentRowView( options );
            $appointmentsContainer.append( appointmentRowView.render().el );
        }
	},
	renderSpecificAppointment: function(model) {
	    var self = this;

        var options = {
            "model": model,
            "socket": this.socket,
            "client": this.client,
        };

        var appointmentRowView = new AppointmentRowView( options );
        self.$el.find(".appointmentsContainer").append( appointmentRowView.render().el );
	}
});

